/*
 * @Author: tony.zhu
 * @Date: 2023-12-04 10:48:02
 * @LastEditTime: 2023-12-04 10:48:18
 * @LastEditors: tony.zhu
 * @Description: 
 */

import DataType from './type';

const _storageType = {
    Local: 'local',
    Session: 'session'
}

/**
 * @method 基础判断
 * @param storageType 存储类型
 * @param encryptType 加密类型
 */
const _core = (storageType = _storageType.Local, encryptType) => {
    if (!encryptType) {
        return {
            storage: storageType === _storageType.Local ? localStorage : sessionStorage
        }
    }
}

export default class Storage {
    /**
     * @method 将键值存入本地存储
     * @param {String} key 键
     * @param {*} value 值
     * @param {String} type 类型 默认storageType.Local
     */
    static set(key, value, type = 'local') {
        const {
            storage
        } = _core(type, '');
        let _processed_value = DataType.isObject(value) || DataType.isArray(value) ? JSON.stringify(value) : value;
        storage.setItem(key, _processed_value);
    }

    /**
     * @method 根据key取本地存储数据
     * @param {String} key 键
     * @param {String} type 类型 默认storageType.Local
     */
    static get(key, type = 'local') {
        const {
            storage
        } = _core(type, '');
        let _stoarge_value = storage.getItem(key);
        try {
            return JSON.parse(_stoarge_value);
        } catch (err) {
            return _stoarge_value;
        }
    }

    /**
     * @method 根据key删除本地存储数据
     * @param {String} key 键
     * @param {String} type 类型 默认storageType.Local
     */
    static remove(key, type = 'local') {
        const {
            storage
        } = _core(type, '');
        storage.removeItem(key)
    }

    /**
     * @method 清空本地存储
     * @param {String} type 类型 默认storageType.Local
     */
    static clear(type = 'local') {
        const {
            storage
        } = _core(type, '');
        storage.clear();
    }

    /**
     * @method 根据key查询本地存储中是否存在key的实例
     * @param {String} key 键
     * @param {String} type 类型 默认storageType.Local
     */
    static had(key, type = 'local') {
        const {
            storage
        } = _core(type, '');
        return key in storage;
    }

    /**
     * @method 获取存储库里存储实例个数
     * @param {String} type 
     */
    static count(type = 'local') {
        const {
            storage
        } = _core(type, '');
        return storage.length
    }
}